
import * as React from "react"
import { Collapsible as ShadcnCollapsible, CollapsibleContent as ShadcnCollapsibleContent, CollapsibleTrigger as ShadcnCollapsibleTrigger } from "@/components/ui/collapsible"
import { cn } from "@/lib/utils"

export interface EnhancedCollapsibleProps extends React.ComponentPropsWithoutRef<typeof ShadcnCollapsible> {
  children?: React.ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}

export const EnhancedCollapsible = ({ children, className, ...props }: EnhancedCollapsibleProps) => {
  return (
    <ShadcnCollapsible className={cn(className)} {...props}>
      {children}
    </ShadcnCollapsible>
  );
};
EnhancedCollapsible.displayName = "EnhancedCollapsible";

export interface EnhancedCollapsibleTriggerProps extends React.ComponentPropsWithoutRef<typeof ShadcnCollapsibleTrigger> {
  children?: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

export const EnhancedCollapsibleTrigger = ({ children, asChild, className, ...props }: EnhancedCollapsibleTriggerProps) => {
  return (
    <ShadcnCollapsibleTrigger asChild={asChild} className={cn(className)} {...props}>
      {children}
    </ShadcnCollapsibleTrigger>
  );
};
EnhancedCollapsibleTrigger.displayName = "EnhancedCollapsibleTrigger";

export interface EnhancedCollapsibleContentProps extends React.ComponentPropsWithoutRef<typeof ShadcnCollapsibleContent> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedCollapsibleContent = ({ children, className, ...props }: EnhancedCollapsibleContentProps) => {
  return (
    <ShadcnCollapsibleContent className={cn(className)} {...props}>
      {children}
    </ShadcnCollapsibleContent>
  );
};
EnhancedCollapsibleContent.displayName = "EnhancedCollapsibleContent";

// Export the enhanced components as the default names
export const Collapsible = EnhancedCollapsible;
export const CollapsibleContent = EnhancedCollapsibleContent;
export const CollapsibleTrigger = EnhancedCollapsibleTrigger;
